import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLink } from '../../hooks/useLink.js';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
export const TopItem = JSX(({ className = '', active, flat, children, data, ...rest }) => {
    const link = useLink();
    const { href, target, text, onClick } = link(rest);
    return (_jsx("a", { className: style(getLinkStyle(active, flat), className), href: href, target: target, onClick: onClick, rel: "noopener noreferrer", "aria-label": `Ссылка на ${text}`, ...getAspectsAttributes(data), children: _jsx("span", { suppressHydrationWarning: true, className: getTextStyle(active, flat), children: text || children }) }));
});
const getLinkStyle = (active = false, flat = false) => style('inline-block border border-solid bg-transparent text-center no-underline', active
    ? 'rounded-md border-primary-main group-data-transparent:border-white'
    : 'border-transparent', {
    'px-m py-xs': !flat,
});
const getTextStyle = (active = false, flat = false) => {
    const activeFlatStyle = flat ? 'text-primary-text' : 'text-secondary-text';
    return style('font-sans text-s font-light', active ? 'text-primary-main' : style(activeFlatStyle, 'hover:text-primary-main'), 'group-data-transparent:text-white group-data-transparent:hover:text-primary-hover');
};
//# sourceMappingURL=TopItem.js.map